export const MEDICAL_FAQ = {
  KOR: [
    {
      title: 'Q. 환급액은 언제 받을 수 있나요?',
      contents:
        '환급액은 출국 확인 후 송금 완료까지 영업일 기준 14일 정도 소요됩니다.',
    },
    {
      title: 'Q. 환급절차가 어떻게 되나요?',
      contents: (
        <span style={{ color: '#3a3b3e' }}>
          • 인천공항 방문시
          <br />
          공항 키오스크에 여권 스캔 → 환급창구에서 환급
          <br />
          <br />• 그 외 출국장 방문시
          <br />
          송금정보 입력 → 출국확인 → 송금 진행
        </span>
      ),
    },
    {
      title: 'Q. 절차를 완료했는데 환급을 못 받았어요.',
      contents: (
        <span style={{ color: '#3a3b3e' }}>
          환급액은 출국 확인 후 송금까지 영업일 기준 10일 정도 소요됩니다.
          <br />
          송금정보가 오기입 되었다면 수정 요청 드릴 예정입니다.
        </span>
      ),
    },
  ],
  ENG: [
    {
      title: 'Q. How long does the refund take?',
      contents:
        'Your refund is usually processed within about 14 business days after your departure has been confirmed.',
    },
    {
      title: 'Q. What is the refund procedure?',
      contents: (
        <span>
          <span style={{ fontWeight: 500 }}>
            If departing from Incheon Airport:
          </span>
          <br />
          <span
            style={{
              display: 'inline-block',
              paddingLeft: '4px',
              color: '#3a3b3e',
            }}
          >
            • Scan your passport at the airport kiosk
            <br />• Receive your refund at the refund counter
          </span>
          <br />
          <br />
          <span style={{ fontWeight: 500 }}>
            If departing from other region:
          </span>
          <br />
          <span
            style={{
              display: 'inline-block',
              paddingLeft: '4px',
              color: '#3a3b3e',
            }}
          >
            • Enter your account information on the KTP website
            <br />• Your refund will be sent via bank transfer after departure.
          </span>
        </span>
      ),
    },
    {
      title: 'Q. I completed all the steps but haven’t received my refund yet.',
      contents: (
        <span style={{ color: '#3a3b3e' }}>
          It can take up to 10 business days from Customs approval for the
          transfer to reach your account.
          <br />
          <br />
          <span
            style={{
              display: 'inline-block',
              paddingLeft: '4px',
              color: '#3a3b3e',
            }}
          >
            • If your bank/transfer information was entered incorrectly, we will
            contact you to correct it.
          </span>
        </span>
      ),
    },
  ],
};

export const HOTEL_FAQ = {
  KOR: [
    {
      title: 'Q. 환급절차가 어떻게 되나요?',
      contents:
        'KTP 키오스크 혹은 공항 방문시 여권 스캔만으로 환급을 받으실 수 있습니다.',
    },
    {
      title: 'Q. 환급을 받지 못하고 출국한 경우에도 환급 받을 수 있나요?',
      contents:
        '웹에 접속하여 [송금으로 받기]를 선택 후 계좌정보를 입력해주세요. 영업일 기준 21일 내에 환급액이 송금됩니다.',
    },
  ],
  ENG: [
    {
      title: 'Q. What is the refund procedure?',
      contents:
        'You can receive your refund by scanning your passport at a KTP refund kiosk or at the airport.',
    },
    {
      title:
        'Q. Can I still get a refund if I left the country without receiving it?',
      contents:
        'Please visit the website, select [Receive via Remittance], and enter your bank account information.\nThe refund will be transferred within 21 business days.',
    },
  ],
};

export const STORE_FAQ = {
  KOR: [
    {
      title: 'Q. 환급액은 언제 받을 수 있나요?',
      contents:
        '환급액은 출국 확인 후 송금 완료까지 영업일 기준 14일 정도 소요됩니다.',
    },
    {
      title: 'Q. 환급절차가 어떻게 되나요?',
      contents: (
        <span style={{ color: '#3a3b3e' }}>
          • 인천공항 방문시
          <br />
          공항 키오스크에 여권 및 영수증 스캔 → 세관 방문 후 물품 확인 →
          환급창구에서 환급
          <br />
          <br />• 그 외 출국장 방문시
          <br />
          송금정보 입력 → 세관 방문 후 물품 확인 → 송금 진행
          <br />
          <br />
          KTP 웹사이트에서 송금정보를 입력하고 세관에 방문하여 구매한 물품과
          모바일 전표를 직원에게 보여주세요. 세관 확인 후 환급액 송금이
          진행됩니다.
        </span>
      ),
    },
    {
      title: 'Q. 절차를 완료했는데 환급을 못 받았어요.',
      contents: (
        <span style={{ color: '#3a3b3e' }}>
          환급액은 세관 확인 후 송금까지 영업일 기준 10일 정도 소요됩니다.
          <br />
          송금정보가 오기입 되었다면 수정 요청 드릴 예정이고, 세관의 확인을 받지
          못한 경우에는 환급이 불가능합니다. 세관 확인을 받으셨다면 송금 정보를
          다시 한 번 확인해주세요.
        </span>
      ),
    },
    {
      title: 'Q. 세관 확인을 받지 못하고 출국했는데 환급이 가능한가요?',
      contents: '세관의 확인을 받지 않고 출국한 경우에는 환급이 불가능합니다.',
    },
  ],
  ENG: [
    {
      title: 'Q. How long does the refund take?',
      contents:
        'Your refund is usually processed within about 14 business days after your departure has been confirmed.',
    },
    {
      title: 'Q. What is the refund procedure?',
      contents: (
        <span>
          <span style={{ fontWeight: 500 }}>
            If departing from Incheon Airport:
          </span>
          <br />
          <span
            style={{
              display: 'inline-block',
              paddingLeft: '4px',
              color: '#3a3b3e',
            }}
          >
            • Scan your passport and receipts at the airport kiosk
            <br />• Visit Customs for goods inspection
            <br />• Receive your refund at the refund counter
          </span>
          <br />
          <br />
          <span style={{ fontWeight: 500 }}>
            If departing from other region:
          </span>
          <br />
          <span
            style={{
              display: 'inline-block',
              paddingLeft: '4px',
              color: '#3a3b3e',
            }}
          >
            • Enter your account information on the KTP website
            <br />• Visit Customs for goods inspction
            <br />• Your refund will be sent via bank transfer
          </span>
        </span>
      ),
    },
    {
      title: 'Q. I completed all the steps but haven’t received my refund yet.',
      contents: (
        <span style={{ color: '#3a3b3e' }}>
          It can take up to 10 business days from Customs approval for the
          transfer to reach your account.
          <br />
          <br />
          <span
            style={{
              display: 'inline-block',
              paddingLeft: '4px',
              color: '#3a3b3e',
            }}
          >
            • If your account information was entered incorrectly, we will send
            email you to correct it.
            <br />
            • No refund can be issued without Customs validation.
            <br />
            • If you did receive Customs validation, please double-check your
            transfer details and allow the full processing time.
            <br />
          </span>
        </span>
      ),
    },
    {
      title:
        'Q. Can I still get a tax refund if I left the country without customs validations?',
      contents:
        'Unfortunately, customs validation is required to process your tax refund. If you did not receive a customs stamp at departure, you may not be eligible for a refund.',
    },
  ],
};

export const FAQ = {
  KOR: {
    title: 'KTP 고객센터',
    contents: (
      <>
        문의사항이 있을 경우,
        <br />
        1:1 고객지원을 통해 메시지를 남겨주세요.
      </>
    ),
    btnText: '1:1 고객지원',
  },
  ENG: {
    title: 'KTP Customer Support',
    contents: (
      <>
        If you have any questions,
        <br />
        Please leave message through 1:1 Support.
      </>
    ),
    btnText: '1:1 Customer support',
  },
};

export const PASSPORT = {
  KOR: {
    title: '여권 번호 입력',
    contents: '여권 번호를 입력해주세요.',
    label: '여권번호',
    placeholder: '여권번호를 입력해주세요.',
    btnText: '다음으로',
  },
  ENG: {
    title: '1:1 Support',
    contents: (
      <>
        Please enter your
        <br />
        passport number.
      </>
    ),
    label: 'Passport Number',
    placeholder: 'Enter your passport number.',
    btnText: 'Next',
  },
};

export const EMAIL = {
  KOR: {
    title: '1:1 고객지원',
    subTitle: '이메일 주소를 입력해 주세요.',
    contents: '문의 답변이 도착하면 고객님의 이메일로 알림이 발송됩니다.',
    label: '이메일',
    placeholder: '이메일 주소를 입력해주세요.',
    btnSend: '인증 메일 발송하기',
    btnNext: '다음으로',
    error: '올바른 양식을 입력해주세요.',
  },
  ENG: {
    title: '1:1 Support',
    subTitle: (
      <>
        Enter your Email
        <br />
        to receive reply notifications
      </>
    ),
    contents:
      'You will receive a notification at your email when a reply to your inquiry arrives.',
    label: 'Email',
    placeholder: 'Enter your Email address',
    btnSend: 'Send verification mail',
    btnNext: 'Next',
    error: 'Please enter a valid email address.',
  },
};

export const EMAIL_SEND_MODAL = {
  KOR: {
    title: '인증 메일 발송완료',
    description: '메일함을 확인하여 인증을 진행해주세요.',
    button: '확인',
  },
  ENG: {
    title: 'Verification mail sent',
    description: 'Please check your mailbox and verify your email.',
    button: 'Confirm',
  },
};

export const EMAIL_COMPLETE_MODAL = {
  KOR: {
    title: '메일 인증완료',
    description: '정상적으로 문의하기를 이용하실 수 있습니다.',
    button: '확인',
  },
  ENG: {
    title: 'Verification Complete',
    description: 'You can send Inquiry.',
    button: 'Confirm',
  },
};

export const EMAIL_FAILED_MODAL = {
  KOR: {
    title: '인증 실패',
    description:
      '메일함을 확인하여 인증을 진행해주세요. 인증 메일을 받지 못하셨다면, 이메일 주소를 확인 후 메일을 재전송하여 인증을 다시 진행해주세요.',
    button: '확인',
  },
  ENG: {
    title: 'Verification Failed',
    description:
      'Please check your mailbox and verify. If you didn’t receive the verification mail, please check your mail address and click the re-send button.',
    button: 'Close',
  },
};

export const QNA = {
  KOR: {
    title: '1:1 고객지원',
    passport: '여권번호',
    email: '이메일',
    empty: '작성된 문의가 없습니다.',
    btnText: '문의 작성하기',
    modifyEmail: '변경',
  },
  ENG: {
    title: '1:1 support',
    passport: 'Passport No.',
    email: 'Email',
    empty: 'No inquiries have been created.',
    btnText: 'Send a message',
    modifyEmail: 'Modify',
  },
};

export const QNA_SEND_MESSAGE_MODAL = {
  KOR: {
    title: 'KTP 문의하기',
    placeholder:
      '서비스 이용 절차 등 궁금하신 사항을 남겨주세요. 문의 내용을 확인하여 빠르게 연락드리도록 하겠습니다.',
    description:
      'PDF파일 및 이미지 파일(GIF, PNG, JPG) 기준으로 최대 10MB이하, 최대 4장까지 첨부 가능합니다.',
    btnCancel: '취소',
    btnSend: '전송',
  },
  ENG: {
    title: 'KTP Inquiry',
    placeholder:
      "Leave us a message with your questions. We'll read it and get back to you as soon as possible.",
    description:
      'You can upload up to 4 files (PDF, GIF, PNG, JPG), each under 10MB.',
    btnCancel: 'Cancel',
    btnSend: 'Send',
  },
};

export const QNA_MODIFY_EMAIL_MODAL = {
  KOR: {
    title: '이메일 변경',
    label: '이메일',
    placeholder: '이메일 주소를 입력해주세요.',
    description: '알림 받을 새로운 메일을 입력해주세요.',
    btnCancel: '취소',
    btnSend: '변경하기',
    error: '올바른 양식을 입력해주세요.',
  },
  ENG: {
    title: 'Modify Email',
    label: 'Email',
    placeholder: 'Enter your Email address',
    description: (
      <>
        Enter the new email to receive
        <br />
        reply notifications
      </>
    ),
    btnCancel: 'Cancel',
    btnSend: 'Modify',
    error: 'Please enter a valid email address.',
  },
};

export const QNA_MODIFY_EMAIL_SUCCESS_MODAL = {
  KOR: {
    title: '이메일 변경완료',
    description: '이메일 주소가 변경되었습니다.',
    button: '확인',
  },
  ENG: {
    title: 'Modify Completed',
    description: (
      <>
        Your email address has been
        <br />
        successfully updated.
      </>
    ),
    button: 'Confirm',
  },
};

export const ANSEWERED_MODAL = {
  KOR: {
    title: '문의 답변 완료',
    contents:
      '문의에 대한 답변이 완료되었습니다.\n1:1 고객지원으로 이동하여 답변을 확인해주세요',
    btnText: '답변 확인하기',
  },
  ENG: {
    title: 'Response Completed',
    contents:
      'The reply to your inquiry is now available.\nPlease check it via 1:1 Customer support.',
    btnText: 'Check response',
  },
};

export const QNA_TIME_LIMIT = {
  KOR: {
    title: '상담 가능 시간 참고해주세요.',
    contents:
      'KTP는 평일 오전 8시부터 오후 5시까지 영업합니다. 이 시간 이후의 질문은 다음 날 오전 8시부터 순차적으로 답변 드립니다.',
  },
  ENG: {
    title: 'Please refer to this',
    contents:
      'KTP is open from 8 a.m. to 5 p.m. on weekdays in Korean time. Questions after this time will be answered sequentially from 8 a.m. the next day.',
  },
};
